import clsx from "clsx";
import { useContext, useMemo } from "react";
import List from "@mui/material/List";
import { TabsMenuContext } from "contexts/TabsMenuContext";
import NavLink from "./NavLink";
import { Icon } from "components/Icon";

type TProps = {
  className?: string;
};
const PinnedItems = (props: TProps) => {
  const { className } = props;
  const tabsMenuContext = useContext(TabsMenuContext);
  const { menu } = tabsMenuContext;

  const hasPinnedMenu = useMemo(() => {
    let result = false;
    for (const menuItem of menu) {
      for (const item of menuItem.children) {
        if (item.isPinned) {
          result = true;
          break;
        }
      }
    }
    return result;
  }, [menu]);

  const renderItems = () => {
    return menu.map((menuItem) => {
      return menuItem.children.map((item, index) => {
        if (item.isPinned) {
          return (
            <div className={"mr w-full"} key={index}>
              <NavLink item={item} />
            </div>
          );
        }
      });
    });
  };

  return (
    <>
      {!hasPinnedMenu ? (
        <></>
      ) : (
        <div
          className={clsx(
            "flex flex-col items-end w-full justify-start",
            className
          )}
        >
          <div
            className={"flex w-full justify-start rtl items-center px-4 h-6"}
          >
            <Icon
              fontSize={"18px"}
              className={"text-gray-130"}
              icon="MdOutlinePushPin"
            />
            <span className={"text-xs text-gray-130 font-bold mr-1"}>
              سنجاق شده:
            </span>
          </div>
          <List
            style={{ direction: "rtl" }}
            className="w-full overflow-y-auto max-h-[400px] pr-6"
            sx={{ pt: 0, "& > :first-of-type": { mt: "0" } }}
          >
            {renderItems()}
          </List>
          <div className={"h-[1px] w-5/6 bg-gray-40 m-auto"} />
        </div>
      )}
    </>
  );
};

export default PinnedItems;
